<template>
  <div v-if="showPopup" class="secret-key-overlay">
    <div class="secret-key-modal">
      <!-- Header -->
      <div class="secret-key-header">
        <div class="header-icon">
          <i class="fa fa-lock"></i>
        </div>
        <h2 class="secret-key-title">Akses Staging Adalah Terhad</h2>
        <p class="secret-key-subtitle">Masukkan Secret Key untuk meneruskan</p>
      </div>

      <!-- Content -->
      <div class="secret-key-content">
        <div class="secret-key-input-group">
          <label class="secret-key-label">Secret Key</label>
          <div class="secret-key-input-wrapper">
            <input 
              ref="secretKeyInput"
              v-model="secretKeyInput"
              :type="showPassword ? 'text' : 'password'"
              class="secret-key-input"
              placeholder="Masukkan secret key..."
              @keyup.enter="verifySecretKey"
              autofocus
            />
            <button 
              type="button" 
              class="toggle-password-btn"
              @click="showPassword = !showPassword"
            >
              <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>
        </div>

        <!-- Error Message -->
        <transition name="fade">
          <div v-if="errorMessage" class="secret-key-error">
            <i class="fa fa-exclamation-circle"></i>
            {{ errorMessage }}
          </div>
        </transition>
      </div>

      <!-- Footer Actions -->
      <div class="secret-key-footer">
        <button 
          class="secret-key-btn cancel-btn" 
          @click="cancelLogin"
        >
          <i class="fa fa-times"></i>
          Batal
        </button>
        <button 
          class="secret-key-btn verify-btn" 
          @click="verifySecretKey"
          :disabled="!secretKeyInput"
        >
          <i class="fa fa-check"></i>
          Sahkan
        </button>
      </div>

      <!-- Info Text -->
      <div class="secret-key-info">
        <i class="fa fa-info-circle"></i>
        Hubungi pentadbir sistem untuk mendapatkan secret key
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecretKeyPopup',
  props: {
    secretKeyEnabled: {
      type: Boolean,
      default: false
    },
    secretKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showPopup: true,
      secretKeyInput: '',
      showPassword: false,
      errorMessage: ''
    }
  },
  mounted() {
    // Prevent page scroll when popup is shown
    document.body.style.overflow = 'hidden'
    
    // Auto-focus input after a short delay
    this.$nextTick(() => {
      if (this.$refs.secretKeyInput) {
        this.$refs.secretKeyInput.focus()
      }
    })
  },
  beforeUnmount() {
    // Restore scroll when component is destroyed
    document.body.style.overflow = 'auto'
  },
  methods: {
    verifySecretKey() {
      if (!this.secretKeyInput.trim()) {
        this.showError('Sila masukkan secret key')
        return
      }

      // Check if the entered secret key matches
      if (this.secretKeyInput === this.secretKey) {
        // Hide popup
        this.showPopup = false
        document.body.style.overflow = 'auto'
        
        // Emit verified event to parent
        this.$emit('verified')
        
        // Clear input
        this.secretKeyInput = ''
      } else {
        this.showError('Secret key tidak sah. Sila cuba lagi.')
        this.secretKeyInput = ''
      }
    },
    
    cancelLogin() {
      // User cancelled, close popup without verifying
      this.showPopup = false
      document.body.style.overflow = 'auto'
      this.secretKeyInput = ''
      
      // Emit close event to parent
      this.$emit('close')
    },
    
    showError(message) {
      this.errorMessage = message
      setTimeout(() => {
        this.errorMessage = ''
      }, 3000)
    }
  }
}
</script>

<style scoped>
.secret-key-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.secret-key-modal {
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  max-width: 500px;
  width: 90%;
  padding: 0;
  animation: slideIn 0.4s ease;
  border: 2px solid rgba(255, 255, 255, 0.1);
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.secret-key-header {
  text-align: center;
  padding: 40px 30px 30px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(251, 191, 36, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 10px 30px rgba(251, 191, 36, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 15px 40px rgba(251, 191, 36, 0.6);
  }
}

.header-icon i {
  font-size: 36px;
  color: white;
}

.secret-key-title {
  font-size: 28px;
  font-weight: 700;
  color: white;
  margin: 0 0 10px 0;
  font-family: 'Chakra Petch', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.secret-key-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-family: 'Chakra Petch', sans-serif;
}

.secret-key-content {
  padding: 30px;
}

.secret-key-input-group {
  margin-bottom: 20px;
}

.secret-key-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: white;
  margin-bottom: 10px;
  font-family: 'Chakra Petch', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.secret-key-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.secret-key-input {
  width: 100%;
  padding: 15px 50px 15px 20px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.95);
  color: #1e3a8a;
  font-family: 'Chakra Petch', sans-serif;
  transition: all 0.3s ease;
  outline: none;
}

.secret-key-input:focus {
  border-color: #fbbf24;
  box-shadow: 0 0 0 4px rgba(251, 191, 36, 0.2);
  background: white;
}

.secret-key-input::placeholder {
  color: #94a3b8;
}

.toggle-password-btn {
  position: absolute;
  right: 15px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  font-size: 18px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.toggle-password-btn:hover {
  color: #1e3a8a;
}

.secret-key-error {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  color: #fee2e2;
  font-size: 14px;
  font-family: 'Chakra Petch', sans-serif;
  animation: shake 0.5s;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.secret-key-error i {
  font-size: 16px;
}

.secret-key-footer {
  padding: 0 30px 30px;
  display: flex;
  gap: 15px;
}

.secret-key-btn {
  flex: 1;
  padding: 15px 30px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Chakra Petch', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.cancel-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 0 10px 25px rgba(239, 68, 68, 0.3);
}

.cancel-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(239, 68, 68, 0.4);
}

.verify-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.3);
}

.verify-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(16, 185, 129, 0.4);
}

.verify-btn:active:not(:disabled) {
  transform: translateY(0);
}

.verify-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.secret-key-info {
  padding: 20px 30px 30px;
  text-align: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Chakra Petch', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.secret-key-info i {
  font-size: 14px;
}

/* Fade transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Responsive */
@media (max-width: 600px) {
  .secret-key-modal {
    max-width: 95%;
  }

  .secret-key-title {
    font-size: 24px;
  }

  .header-icon {
    width: 70px;
    height: 70px;
  }

  .header-icon i {
    font-size: 30px;
  }
  
  .secret-key-footer {
    flex-direction: column;
  }
}
</style>